/*
If the content is treated as strict XHTML, the entire structure of tags and attributes
must be correct since any small error will make the browser detect a failure
and override the content with a <parsererror> tag.
 */
export default function fixXhtmlMarkup(stringWithHtmlCode) {
    // Normalize whitespace between an attribute name and its '=' sign.
    //
    // The XML spec actually ALLOWS whitespace around '=' (Eq ::= S? '=' S?), and
    // strict parsers like libxml2 (used by Blink/WebKit's DOMParser) accept
    // `alt ="x"` just fine. The problem is that some of the value-less ("minimized")
    // attribute fixes below assume an attribute name followed by whitespace has no
    // value, so they turn valid `alt ="x"` into `alt=" " ="x"` — which IS invalid
    // XML ("error parsing attribute name"). Collapsing the spurious whitespace up
    // front keeps that markup valid and prevents the fixes below from mangling it.
    //
    // Scoped to start tags via the outer regex so quoted attribute values are never
    // touched; the inner regex only fires when a quote follows the '='.
    stringWithHtmlCode = stringWithHtmlCode.replace(/<[a-zA-Z][^>]*>/g, tag =>
        tag.replace(/(\s[a-zA-Z_:][-\w:.]*)\s+=\s*(["'])/g, '$1=$2')
    );

    // Fix for <meta> tags with missing 'content' attribute values
    stringWithHtmlCode = stringWithHtmlCode.replace(/<meta([^>]*?)\s+content\s*\/>/g, '<meta$1 content=" "/>');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<link([^>]*?)\s+media(?!\s*=)\s+/g, '<link$1 media=" " ');

    // These are cases taken as invalid that we must insert a blank space

    // tag:<img> attribute: alt
    stringWithHtmlCode = stringWithHtmlCode.replace(/<img([^>]*?)\s+alt=""/g, '<img$1 alt=" " ');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<img([^>]*?)\s+alt(?!\s*=)\s+/g, '<img$1 alt=" " ');
    //End of injection

    // tag:<img> attribute: title
    // stringWithHtmlCode = stringWithHtmlCode.replace(
    //     /<img([^>]*?)\s+title=""/g,
    //     '<img$1 title=" " '
    // );
    // stringWithHtmlCode = stringWithHtmlCode.replace(
    //     /<img([^>]*?)\s+title\s+/g,
    //     '<img$1 title=" " '
    // );
    //End of injection

    // tag:<p> attribute: class
    stringWithHtmlCode = stringWithHtmlCode.replace(/<p([^>]*?)\s+class=""/g, '<p$1 class=" " ');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<p([^>]*?)\s+class\s*>/g, '<p$1 class=" " >');
    //End of injection

    // tag:<html> attribute: lang
    stringWithHtmlCode = stringWithHtmlCode.replace(/<html([^>]*?)\s+lang=""/g, '<html$1 ');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<html([^>]*?)\s+lang(?!\s*=)\s+/g, '<html$1 ');
    //End of injection

    // tag:<html> attribute: xml:lang
    stringWithHtmlCode = stringWithHtmlCode.replace(/<html([^>]*?)\s+xml:lang=""/g, '<html$1 xml:lang=" " ');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<html([^>]*?)\s+xml:lang(?!\s*=)\s+/g, '<html$1 xml:lang=" " ');
    stringWithHtmlCode = stringWithHtmlCode.replace(/<html([^>]*?)\s+xml:lang\s*>/g, '<html$1 xml:lang=" ">');
    //End of injection

    /*
    Code injection to make printing difficult, preventing them from exporting the content.
    It is part of improvements we made for the control and security of content within our platform.
    https://publicala.slack.com/archives/C1SCAFZPW/p1707314975820979
    https://app.asana.com/0/1205747822961818/1206545469641808/f
     */
    stringWithHtmlCode = stringWithHtmlCode.replace(
        /<\/head>/i,
        '<style>@media print { * { display: none !important; } }</style></head>'
    );
    //End of injection

    return stringWithHtmlCode;
}
